// @ts-nocheck
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useState, useCallback, useRef} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useFocusEffect} from '@react-navigation/native';
import AsterixDialog from '../../../components/AsterixDialog';
import HeaderTabs from '../../../components/HeaderTabs';
import MySearchbar from '../../../components/MySearchbar';
import NavbarWithAction from '../../../components/NavbarWithAction';
import {GetAlerts, ReadAllAlerts} from '../alertsReducer';
import {RootStore} from '../../../redux/store';
import Approvals from './Approvals';
import Notifications from './Notification';
import FilterPanel from '../components/FilterPanel';
import {GetApprovals} from '../../../redux/reducers/approvalsReducer';
import {GetDeliveries} from '../../Deliveries/deliveriesReducer';
import {GetUnitScreenData} from '../../Units/unitsReducer';
import {usePackagesByUnit} from '../../../hooks/packages';
import {E_NAVIGATION_DESTINATIONS} from '../../../@types';
import Container from '../../../components/Container';
import {useRoute} from '@react-navigation/native';

const Alerts = ({navigation}) => {
  const mountedAtRef = useRef(Date.now());
  const dispatch = useDispatch();
  const [isNavbarShown, setIsNavbarShown] = useState(true);

  const isLoading = useSelector((state: RootStore) => state.alerts.loading);
  const [searchTerm, setSearchTerm] = useState('');
  const [swipeablePanelActive, setSwipeablePanelActive] = useState(false);
  const route = useRoute();
  const [activeTab, setActiveTab] = useState(
    !!route.params?.activeTab ? route.params.activeTab : 'Notifications',
  );
  const {isReadingAll, pageNumber} = useSelector(
    (state: RootStore) => state.alerts,
  );

  const currentUnitId = useSelector((state: RootStore) =>
    state.units.unitLinks?.find(link => link.isDefault === true)?.unit?.id,
  );

  const {} = usePackagesByUnit(currentUnitId, false, false);

  const searchHandler = (searchString: string) => {
    setSearchTerm(searchString);
  };

  useEffect(() => {
    if (!!route.params?.activeTab) {
      setActiveTab(route.params.activeTab);
    }
  }, [route.params]);

  useEffect(() => {
    console.log(
      'Alerts screen mounted in',
      Date.now() - mountedAtRef.current,
      'ms',
    );
  }, []);

  useEffect(() => {
    dispatch(GetAlerts());
    dispatch(GetApprovals());
    dispatch(GetDeliveries());
  }, []);

  // Ensure default unit is set when Alerts screen comes to foreground
  useFocusEffect(
    useCallback(() => {
      dispatch(GetUnitScreenData(false));
    }, [dispatch])
  );

  const renderHeader = () => {
    return (
      <>
        {isNavbarShown ? (
          <NavbarWithAction
            title="Alerts"
            navigation={navigation}
            onClickSearch={() => setIsNavbarShown(false)}
            hasFilter={!isLoading}
            onClickFilter={() => setSwipeablePanelActive(true)}
            hasMoreMenu
            hasSignOut
            hasReadAll
            hasSwitchUnit
            readAll={() => {
              dispatch(ReadAllAlerts());
            }}
            switchUnit={() => {
              navigation.navigate('Units');
            }}
            hasAccessCard
            onClickAccessCard={() =>
              navigation.navigate(E_NAVIGATION_DESTINATIONS.ID_CARD)
            }
            fullScreen
            showDefaultUnitLabel
          />
        ) : (
          <MySearchbar
            placeholder="Search"
            setValue={val => searchHandler(val)}
            resetSearch={() => {
              setIsNavbarShown(true);
              setSearchTerm('');
            }}
          />
        )}
      </>
    );
  };

  return (
    <Container>
      {renderHeader()}
      <HeaderTabs activeTab={activeTab} setActiveTab={setActiveTab} />
      {activeTab === 'Notifications' ? (
        <Notifications searchTerm={searchTerm} />
      ) : (
        <Approvals />
      )}
      <AsterixDialog
        isSwitching={isReadingAll}
        message={'Reading alerts ...'}
      />
      <FilterPanel
        panelActive={swipeablePanelActive}
        setPanelActive={(newState: boolean) =>
          setSwipeablePanelActive(newState)
        }
        activeTab={activeTab}
      />
    </Container>
  );
};

export default Alerts;
